<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <qr-code-make-nfc
        hidden
        ref="qrCanvas"
        v-model="NewqrDesign"
        :identifier="NewidentifierShortLink"
        :file.sync="NewqrSvgDataUrl"
        @save="NewqrDesign = $event"
      />
      <custom-tabs v-model="tabs" :tab-items="tabItems" grow class="ma-4">
        <template v-slot:staticItems>
          <!-- تب اول -->
          <v-tab-item>
            <v-card :loading="loading" flat>
              <list-card-header
                ref="listCardHeader"
                v-model="checkAll"
                :count="(pagination && pagination.total) || 0"
                :is-loading="loading"
                :mass-update-price="massUpdatePrice"
                :massUpdate="massUpdate"
                :massUpdatePriceData="massUpdatePriceData"
                :qr-card="list.filter((item) => item.checkbox)"
                :show-check="showCheck"
                :qrTypeCounts="listDetail"
                @check="changeCheckAll"
                @emit-loading="loading = $event"
                @pause-sel="pauseSelected"
                @bulk-download="bulkDownload"
              >
                <template v-slot:extension>
                  <v-card flat max-width="150 pa-0 ma-0 d-flex align-center">
                    <div
                      class="pa-0 d-flex row rowinfo align-center"
                      v-if="!tableView"
                    >
                      <v-select
                        ref="paginationTop"
                        v-model="computedPerPage"
                        :items="['10', '25', '50', '100', '200', '300']"
                        :menu-props="{ offsetY: true }"
                        class="ma-2 my-md-0 contentinfo"
                        dense
                        hide-details
                        :label="$t('display_count')"
                        outlined
                        @input="onPerPage"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-computedPerPage`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('display_count')"
                      />
                    </div>
                    
                  </v-card>
                  <v-spacer />
              <v-btn-toggle 
                      v-model="minimaltableView"
                      mandatory
                      dense
                      class="mx-5 typechoice"
                      color="primary"
                    >
                      <v-btn :value="false" :title="$t('gridShow')">
                        <v-icon>mdi-view-grid</v-icon>
                      </v-btn>

                      <v-btn :value="true" :title="$t('tableShow')">
                        <v-icon>mdi-format-list-bulleted</v-icon> <!-- یا mdi-table -->
                      </v-btn>
                    </v-btn-toggle>
                </template>
              </list-card-header>

              
              <v-row class="px-8" no-gutters ref="scrollContainer">
                <template v-if="!tableView">
                  <v-col v-for="(x, i) in list" :key="x.id||x.qrId" class="mb-3" cols="12">
                      <!-- حالت جدولی: استفاده از qr-list-item -->
                    <qr-list-item   
                      v-if="minimaltableView"                    
                      v-model="x.checkbox"
                      :localInfo="x"
                      :key="x.id||x.qrId"
                      :price-loading="priceloading"
                      :show-check="showCheck"
                      v-bind="listAttrs"
                      @fetch="minimalFetch"
                      @show="showModal"
                      @print-qr="printQr"
                      :image-loading-from-parent="
                        imageLoadingMap[x.qrId] || false
                      "
                      />
                     <!-- حالت نمایشی: استفاده از card-list-user -->
                    <card-list-user
                    v-else
                      v-model="x.checkbox"
                      :info="x"
                      :price-loading="priceloading"
                      :key="`user-${x.id||x.qrId}`"
                      :show-check="showCheck"
                      v-bind="listAttrs"
                      @fetch="fetch"
                      @show="showModal"
                      @print-qr="printQr"
                      :image-loading-from-parent="
                        imageLoadingMap[x.qrId] || false
                      "
                    />
                  </v-col>
                </template>
                <v-col
                  v-if="pagination && pagination.data"
                  class="px-4"
                  cols="12"
                >
                  <pagination
                    v-if="pagination && pagination.data"
                    ref="paginationTableBottom"
                    :data="pagination"
                    :per-page.sync="computedPerPage"
                    @page="onPagination"
                  >
                    <template v-slot:per-page>
                      <v-select
                        ref="paginationTableBottom2"
                        v-model="computedPerPage"
                        :items="['10', '25', '50', '100', '200', '300']"
                        :menu-props="{ offsetY: true }"
                        class="ma-2 my-md-0"
                        dense
                        :label="$t('display_count')"
                        outlined
                        @input="onPerPage"
                      />
                    </template>
                  </pagination>
                </v-col>
              </v-row>

              <v-card
                v-if="
                  !loading &&
                  list.length <= 0 &&
                  (!pagination || pagination.total <= 0)
                "
                class="d-flex align-center justify-center"
                flat
                height="300"
                width="100%"
              >
                <v-card-title class="justify-center text-center"
                  >{{ $t("no_qr_to_display") }}
                </v-card-title>
              </v-card>
            </v-card>
          </v-tab-item>

          <!-- تب دوم -->
          <v-tab-item>
            <v-card :loading="loadinggroup" flat>
              <list-card-headergroup
                ref="listCardHeadergroup"
                v-model="checkAllgroup"
                :count="countDatagroup"
                :rowcount="selectedRowsgroup.length"
                :is-loading="loadinggroup"
                :mass-update-price="massUpdatePricegroup"
                :massUpdate="massUpdateGroup"
                :massUpdatePriceData="massUpdatePriceDatagroup"
                :qr-card="filteredListgroup"
                :show-check="false"
                :qrTypeCounts="listDetail"
                @resetFilters="resetFilters"
                @check="changeCheckAllgroup"
                @emit-loading="loadinggroup = $event"
                @pause-sel="pauseSelectedgroup"
                :typeChoice="!typeChoice"
              >
                <template v-slot:content></template>
                <template v-slot:extension>
                  <v-row no-gutters class="mx-7">
                    <v-col cols="3" md="3" lg="3" class="ma-0 pa-0 dic">
                      <span class="ma-0 pa-0 countshow">
                        {{ $t("total_qr_codes") }}:
                        {{ persian(countDatagroup) }}</span
                      >
                      <v-switch
                        class="typechoice py-0 may-0"
                        v-model="typeChoice"
                        :label="$t('select_all')"
                        inset
                        hide-details
                        dense
                      ></v-switch>
                    </v-col>
                    <v-col cols="6" class="ma-0 pa-0">
                      <v-card flat class="ma-0 pa-0">
                        <v-card-text
                          class="d-flex ma-0 pb-5"
                          style="
                            justify-content: center !important;
                            align-items: center;
                            color: black;
                          "
                        >
                          {{
                            !typeChoice
                              ? $t("selected_qr_codes_count")
                              : $t("qr_codes_count")
                          }}
                          {{
                            !typeChoice
                              ? persian(selectedRowsgroup.length)
                              : persian(countDatagroup)
                          }}
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3" md="3" lg="3" class="ma-0 pa-0"></v-col>
                  </v-row>
                </template>
              </list-card-headergroup>
              <v-row>
                <v-col
                  v-if="
                    !typeChoice &&
                    typeFiltergroup === 'all' &&
                    !(!!paginationgroup && paginationgroup.data.length > 0)
                  "
                  class="messageEmpty"
                  >{{ $t("for_group_renewal_select_desired_qr_codes") }}
                </v-col>
                <v-col
                  v-if="
                    !typeChoice &&
                    !!paginationgroup &&
                    paginationgroup?.data?.length > 0
                  "
                  style="width: 100%"
                  class="pa-4"
                >
                  <vue-table
                    ref="dynamicData"
                    v-model="selectedRowsgroup"
                    :data="paginationgroup"
                    :headers="headersgroup"
                    :per-page.sync="computedPerPagegroup"
                    item-key="id"
                    show-select
                    @change="onPaginationgroup"
                  >
                    <template v-slot:index="{ item }">
                      {{
                        paginationgroup.data.findIndex(
                          (x) => x.qrId === item.qrId,
                        ) + 1
                      }}
                    </template>
               <template v-slot:type="{ item }">
                  <div class="text-caption mt-2 font-weight-bold d-flex flex-row align-center">
                    
                    <v-badge
                      color="transparent"
                      overlap
                      offset-x="17"
                      offset-y="4"
                      v-if="$vuetify.breakpoint.smAndUp && $options.filters.qrType(item.type, 'pro')"
                    >
                      <template #badge>
                        <v-icon size="12" color="grey darken-2">mdi-crown</v-icon>
                      </template>
                      <v-icon x-small class="ml-1">mdi-{{ getQrTypes(item.type)?.icon||'qrcode-scan' }}</v-icon>
                    </v-badge>

                     <v-icon 
                      v-if="$vuetify.breakpoint.smAndUp && !$options.filters.qrType(item.type, 'pro')"  
                      x-small 
                      class="ml-1"
                    >
                      mdi-{{ getQrTypes(item.type)?.icon||'qrcode-scan' }}
                    </v-icon>                 
                    
                    {{ getQrTypes(item.type)?.name }}
                  </div>
</template>

                    <template v-slot:link="{ item }">
                      <v-icon class="ms-1 me-3" size="22"
                        >mdi-link-variant
                      </v-icon>
                      <a
                        :href="
                          (!item?.domain?.name.startsWith('http') && !item?.domain?.name.startsWith('https')
                            ? 'https://' +
                              item?.domain?.name +
                              item?.identifier
                            : (item?.domain?.name + item?.identifier).replace('http:','https:')
                          )
                        "
                        target="_blank"
                        class="link"
                      >
                        {{
                          (!item?.domain?.name.startsWith("http")
                            ? "https://" + item.domain?.name + item?.identifier
                            : item?.domain?.name + item?.identifier
                          ).replace("https://", "")
                        }}
                      </a>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            v-bind="attrs"
                            @click="
                              copyUrl(
                                (!item?.domain?.name.startsWith('http')
                                  ? 'https://' +
                                    item?.domain?.name +
                                    item?.extra_short?.identifier
                                  : item?.domain?.name +
                                    item?.extra_short?.identifier
                                ).replace('https://', ''),
                              )
                            "
                            v-on="on"
                          >
                            <v-icon small>mdi-content-copy</v-icon>
                          </v-btn>
                        </template>

                        <span>{{ $t("copy") }}</span>
                      </v-tooltip>
                    </template>
                  </vue-table>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </template>
      </custom-tabs>

      <!-- پاپ‌آپ‌ها و کامپوننت‌های مشترک -->

      <custom-popup
        v-model="showDialog"
        :cons="cons"
        hide-confirm
        hide-overlay
        max-width="900"
        transition="dialog-bottom-transition"
      >
        <template v-slot:helpinfo>
          <help-info
            :element-name="`${serviceName}-${componentName}-data-show-download-d`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('download_qr')"
          />
        </template>
        <v-card class="pa-5">
            <download-file-with-api
            v-if="showDialog"
            :visit-name="info.title"
            :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
            @close="showDialog = false"
            :qr_id="info.qrId"
            :is-qrlink="['qrlink','clickyarseo'].includes(info?.type?.toLowerCase())"

          />
        </v-card>
      </custom-popup>
      <print-page v-if="showPrint" v-model="info"  @close="showPrint = false" />

      <qr-users-list
        v-model="showUsersList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        :key="$i18n.locale + 'user'"
        :data="info?.domain?.name + info?.identifier"
      />
      <qr-winners-list
        v-model="showWinnersList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        :key="$i18n.locale + 'winners'"
      />
      <employee-list          
      v-model="showEmployeeList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        :key="$i18n.locale + 'employee'"
/>
      <attendance-list         
      v-model="showAttendanceList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        :key="$i18n.locale + 'Attendance'"
/>

      <transactions-list
        v-model="transactionsShow"
        :infoId="info?.id"
        :key="$i18n.locale + 'transactions'"
      />
      <qr-orders-list
        v-model="showOrdersList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        :key="$i18n.locale + 'order'"
      />
      <qr-appointments-list
        v-model="showAppointmentsList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        :key="$i18n.locale + 'appointments'"
      />
      <qr-feedback-list
        v-model="showFeedBackList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        @fetch="debouncedFetch"
        :key="$i18n.locale + 'feedback'"
      />
      <qr-user-transfer
        v-model="showOwnershipList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        @fetch="debouncedFetch"
        :key="$i18n.locale + 'transfer'"
      />
      <consultation-pop
        v-model="showForm"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        @fetch="debouncedFetch"
        :key="$i18n.locale + 'form'"
      />
      <qr-nfc-list
        v-model="showNfcList"
        :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
        @fetch="fetchNFC"
        :key="$i18n.locale + 'nfc'"
        :initialType="info?.type"
        :qr_id="info?.qrId"
      />
     <custom-popup
  v-model="priceDial"
  :cons="{ title: $t('renew_qr') }"
  hide-confirm
  hide-overlay
  max-width="500"
  transition="dialog-bottom-transition"
  @close="discountField = { show: false, model: '' }"
>
  <div key="prices" class="pa-2 pa-sm-4">
    <custom-tabs
      v-model="tabs2"
      :tab-items="prices"
      :window-items="prices"
      fixed-tabs
    >
      <!-- عنوان تب‌ها -->
      <template v-slot:tab="{ tab }">
        {{ tab?.name || persian(tab.time) + ' ' + $t("days") }}
      </template>

      <!-- راهنمای تب‌ها -->
      <template v-slot:helpinfo="{ tab }">
        <help-info
          :element-name="`${serviceName}-${componentName}-${tab.name}-price`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          :label="`${tab?.name}`"
        />
      </template>

      <!-- محتوای داخل هر تب (طراحی جدید کارت) -->
      <template v-slot:item="{ item }">
        <div class="pt-4 pb-2 px-1">
          <v-card 
            class="mx-auto rounded-xl overflow-visible border position-relative" 
            elevation="0" 
            :style="`border: 2px solid ${getCardStyle(item).color}44 !important;`"
          >
            
            <!-- آیکون نوع کیوآر -->
            <v-icon 
              color="#b0bec5" 
              size="28" 
              style="position: absolute; top: 12px; left: 12px; z-index: 1;"
            >
              mdi-{{ iconQr }}
            </v-icon>

            <v-card-text class="pa-3 text-center">
              
              <!-- تگ و آیکون بالای کارت -->
              <div class="d-flex flex-column align-center mb-2 mt-0">
                <v-icon :color="getCardStyle(item).color" size="22" class="mb-1">
                  {{ getCardStyle(item)?.icon ||qrcode-scan }}
                </v-icon>
                <v-chip
                  :color="getCardStyle(item).color"
                  class="font-weight-bold px-3"
                  dark
                  style="font-size: 12px; height: 24px;"
                >
                  {{ getCardStyle(item).tag }}
                </v-chip>
              </div>

              <!-- سطر قیمت و تعداد روز -->
              <div class="position-relative">
                <div 
                  class="d-flex align-center justify-space-between pa-2 px-8 rounded-lg mb-0 " 
                  style="background: #f8f9fa; margin-left: 45px;"
                >
                  <!-- بخش قیمت -->
                  <div class="d-flex flex-column align-start">
                    <div v-if="!!item.discount" class="text-decoration-line-through grey--text text--lighten-1 mb-0 text-caption">
                      {{ persian(formatPrice(item.price).num) }} {{ formatPrice(item.price).text }}
                    </div>
                    
                    <div class="d-flex align-end" style="gap: 4px;">
                      <span class="font-weight-black" :style="`font-size: 2rem; line-height: 0.9; color: ${getCardStyle(item).color};`">
                        {{ persian(formatPrice(!!item.discount ? computedDiscount(item) : item.price).num) }}
                      </span>
                      <span class="text-caption grey--text text--darken-2 font-weight-medium pb-1">
                        {{ formatPrice(!!item.discount ? computedDiscount(item) : item.price).text }}
                      </span>
                    </div>

                    <v-chip v-if="!!item.discount" class="mt-1 font-weight-bold px-2" color="#ec407a" dark x-small>
                      {{ persian(item.discount) }}% تخفیف
                    </v-chip>
                  </div>

                  <v-divider vertical class="mx-2"></v-divider>

                  <!-- بخش تعداد روز -->
                  <div class="text-center d-flex flex-column align-center pr-1">
                    <span class="font-weight-black" style="font-size: 1.8rem; color: #2c3e50; line-height: 1;">{{ persian(item.time) }}</span>
                    <span class="grey--text text-caption font-weight-regular mt-0">{{ $t("days") }}</span>
                  </div>
                </div>

                <!-- دکمه خرید گرد روی لبه -->
                <div 
                  class="rowinfo d-flex flex-column align-items-center"
                  style="position: absolute; left: -5px; top: 50%; transform: translateY(-50%); z-index: 2;"
                >
                  <v-btn
                    :disabled="discountField.show && priceId === item.id"
                    :loading="priceloading"
                    color="success"
                    fab
                    x-small
                    elevation="2"
                    @click="upgradeQr(item.id)"
                  >
                    <v-icon size="18">mdi-cart-outline</v-icon>
                  </v-btn>
                  <span class="font-weight-bold success--text mt-1" style="font-size: 10px;">{{ $t("i_buy") }}</span>
                  
                  <help-info
                    :disabled="discountField.show"
                    :element-name="`${serviceName}-${componentName}-price-discountField-d`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('i_buy')"
                  />
                </div>
              </div>
            </v-card-text>

            <v-divider class="mx-4 mt-0 mb-1"></v-divider>

            <!-- دکمه افزودن کد تخفیف -->
            <v-card-actions class="pa-1 justify-center position-relative">
              <div class="rowinfo">
                <v-btn
                  :loading="priceloading"
                  color="blue-grey darken-3"
                  text
                  small
                  class="rounded-lg text-caption font-weight-bold"
                  @click="
                    if (priceId === item.id) {
                      discountField.show = !discountField.show;
                    } else {
                      priceId = item.id;
                      discountField.show = true;
                    }
                  "
                >
                  {{ discountField.show && priceId === item.id ? 'بستن فرم تخفیف' : $t("add_discount_code") }}
                </v-btn>
                
                <help-info
                  :disabled="discountField.show"
                  :element-name="`${serviceName}-${componentName}-add-show-discountField-d`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('add_discount_code')"
                />
              </div>
            </v-card-actions>
          </v-card>

          <!-- فرم کد تخفیف (داخل همان تب) -->
          <v-expand-transition>
            <div v-if="discountField.show && priceId === item.id" class="pt-2">
              <v-card class="rounded-lg border pa-0" elevation="0" style="border: 1px solid #e0e0e0 !important; background-color: #fafafa;">
                <v-card-text class="pa-2 rowinfo">
                  <v-text-field
                    v-model="discountField.model"
                    clear-icon="mdi-close"
                    clearable
                    dense
                    hide-details="auto"
                    :label="$t('discount_code')"
                    outlined
                    class="rounded-lg"
                    prepend-inner-icon="mdi-percent-box"
                    background-color="white"
                  >
                    <template v-slot:append-outer>
                      <v-btn
                        :loading="priceloading"
                        class="mt-n1 rounded-lg px-3"
                        color="#26a69a"
                        dark
                        elevation="0"
                        height="38"
                        @click="upgradeQr(priceId)"
                      >
                        {{ $t("submit") }}
                      </v-btn>
                    </template>
                  </v-text-field>
                  
                  <help-info
                    :disabled="discountField.show"
                    :element-name="`${serviceName}-${componentName}-submit-price-discountField-d`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('discount_code')"
                  />
                </v-card-text>
              </v-card>
            </div>
          </v-expand-transition>
        </div>
      </template>
    </custom-tabs>
  </div>
</custom-popup>

    </template>
  </help-info-wrapper>
</template>

<script>
import QrListItem from "./components/cardList/QrListItem.vue";
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import ListCardHeader from "./components/listCardHeader";
import ListCardHeadergroup from "./components/listCardHeadergroup.vue";
import pagination from "../../content/fragments/pagination";
import { mapActions, mapGetters } from "vuex";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import CardListUser from "./components/cardList/cardListUser";
import PrintPage from "../../components/adapters/printPage";
import QrUsersList from "@/view/pages/list/qrUsersList.vue";
import QrOrdersList from "@/view/pages/list/qrOrdersList.vue";
import QrAppointmentsList from "@/view/pages/list/qrAppointmentsList.vue";
import QrUserTransfer from "@/view/pages/list/qrUserTransfer.vue";
import QrNfcList from "@/view/pages/list/qrNfcList.vue";
import QrFeedbackList from "@/view/pages/list/qrFeedbackList.vue";
import consultationPop from "../../components/consultationNew/consultationPop.vue";
import qrCodeMakeNfc from "@/view/pages/qrland/qrCodeStyle/qrCodeMakeNfc.vue";
import QrWinnersList from "./qrWinnersList.vue";
import TransactionsList from "@/view/pages/multiCart/transactionsList/transactionsList.vue";
import { debounce } from 'lodash';
import EmployeeList from "./EmployeeList.vue";
import AttendanceList from "./AttendanceList.vue";


export default {
  name: "qrList",
  components: {
    TransactionsList,
    HelpInfo,
    HelpInfoWrapper,
    QrFeedbackList,
    QrUserTransfer,
    QrNfcList,
    QrAppointmentsList,
    QrOrdersList,
    QrUsersList,
    PrintPage,
    CardListUser,
    DownloadFileWithApi,
    pagination,
    ListCardHeader,
    ListCardHeadergroup,
    consultationPop,
    qrCodeMakeNfc,
    QrWinnersList,
    QrListItem,
    EmployeeList,
    AttendanceList,

  },
  data: () => ({
    minimaltableView:true,
    imageLoadingMap: {},
    NewidentifierShortLink: "",
    listDetail: [],
    paginationDetail: null,
    infoSelected: null,
    showTooltip: false,
    typeChoice: false,
    cachedList: null,
    cachedPagination: null,
    lastCacheKey: null,
    cachedListgroup: null,
    cachedPaginationgroup: null,
    lastCacheKeygroup: null,
    loadinggroup: false,
    listgroup: [],
    selectedTime: null,
    qrTypes: [],
    countData: 0,
    tabs: 0,
    TypeCounts: [],
    TypeCountsgroup: [],
    tabs2: 0,
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrlist",
    showFeedBackList: false,
    showWinnersList: false,
    transactionsShow: false,
    showEmployeeList:false,
    showAttendanceList:false,
    manageItems: [],
    checked: [],
    checkAll: false,
    discountField: {
      show: false,
      model: "",
    },
    showPrint: false,
    list: [],
    pagination: null,
    firstPage: false,
    page: 1,
    priceId: null,
    loading: false,
    info: null,
    showDialog: false,
    priceDial: false,
    priceloading: false,

    prices: [],
    showUsersList: false,
    showOrdersList: false,
    showAppointmentsList: false,
    showForm: false,
    showOwnershipList: false,
    showNfcList: false,
    infoUrl: "",
    massUpdatePriceData: {},
    tableView: false,
    selectedRows: [],
    settings: [],
    listAttrs: {
      images: false,
      settings: false,
      link: false,
    },
    countDatagroup: 0,
    checkedgroup: [],
    checkAllgroup: false,
    paginationgroup: null,
    firstPagegroup: false,
    pagegroup: 1,
    massUpdatePriceDatagroup: {},
    selectedRowsgroup: [],
    NewqrDesign: null,
    NewqrSvgDataUrl: "",
  }),
  mounted() {
    this.manageItems = [
      {
        text: this.$t("table_view"),
        value: () => false,
        handler: () => {
          this.tableView = true;
          this.computedPerPage = "500";
        },
        disabled: () => false,
      },
      {
        text: this.$t("normal_view"),
        value: () => this.listAttrs.images,
        handler: () => {
          this.tableView = false;
          if (parseInt(this.computedPerPage) >= 500) {
            this.computedPerPage = "10";
          }
        },
        disabled: () => !this.tableView,
      },
    ];
    this.$root.$on("fillInfo", this.fillInfo);
    this.$root.$on("getPrices", this.getPrices);
    if (!this.perPageFilter) {
      this.updatePerPageFilter("10");
    }
    if (this.tableView) {
    this.debouncedGroupFetch();
    } else {
      this.debouncedFetch();
    }
    


    this.restoreState();
    this.NewqrDesign = {
      width: 300,
      height: 300,
      data: this.NewidentifierShortLink
        ? `https://qr2.in/${this.NewidentifierShortLink}`
        : "https://qr2.in",
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "H",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#933490" },
            { offset: 1, color: "#933490" },
          ],
        },
      },
      backgroundOptions: { color: "#FFFFFFFF" },
      image: null,
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#6a1a4c",
          color2: "#6a1a4c",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "#690a70",
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      cornersDotOptions: { type: "", color: "#b00cab" },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
    };
  },
  computed: {
    qrDataObject() {
      const types = this.getQrTypes() || [];
      return types.find(
        (item) => item.value.toLowerCase() === (this.info?.type || "").toLowerCase()
      ) || {};
    },
    iconQr() {
      return this.qrDataObject?.icon || "qrcode-scan";
    },
    isInfoValid() {
      return this.info && typeof this.info === "object" && this.info.qrId;
    },
    tabItems() {
      return [
        { text: this.$t("my_qr_list"), icon: "" },
        { text: this.$t("group_renewal"), icon: "" },
      ];
    },
    cons() {
      return {
        title: this.$t("download_qr"),
      };
    },
    headers() {
      return [
        { text: this.$t("row"), value: "index" },
        { text: this.$t("title"), value: "title" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("link"), value: "link" },
        { text: this.$t("visits"), value: "clicks" },
        { text: this.$t("status"), value: "prices" },
        { text: this.$t("creation_time"), value: "created_at_diff" },
        { text: this.$t("edit_time"), value: "updated_at_diff" },
      ];
    },
    headersgroup() {
      return [
        { text: this.$t("row"), value: "index" },
        { text: this.$t("title"), value: "title" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("link"), value: "link" },
      ];
    },
    rowcount() {
      return this.selectedRowsgroup.length;
    },
    ...mapGetters("localstorage", [
      "statusFilter",
      "typeFilter",
      "sortFilter",
      "searchTypeFilter",
      "perPageFilter",
      "perPageFiltergroup",
      "hasFiltergroup",
      "pageFilter",
      "pageFiltergroup",
      "userFilter",
      "identifierFilter",
      "idSearchFilter",
      "expireTypeFilter",
      "statusFiltergroup",
      "typeFiltergroup",
      "sortFiltergroup",
      "searchTypeFiltergroup",
      "userFiltergroup",
      "identifierFiltergroup",
      "idSearchFiltergroup",
      "expireTypeFiltergroup",
    ]),
    computedState() {
      return {
        page: this.computedPage || 1,
        perPage: this.computedPerPage || "10",
        sortFilter: this.sortFilter || "desc",
        statusFilter: this.statusFilter || "all",
        typeFilter: this.typeFilter || "all",
        searchTypeFilter: this.searchTypeFilter || { text: "" },
        userFilter: this.userFilter || null,
        identifierFilter: this.identifierFilter || null,
        idSearchFilter: this.idSearchFilter || null,
        expireTypeFilter: this.expireTypeFilter || null,
        tableView: this.tableView || false,
        scrollPosition: window.scrollY || 0,
        activeTab: this.tabs || 0,
      };
    },
    computedUserFilter: {
      get() {
        return this.userFilter;
      },
      set(val) {
        this.updateUserFilter(val);
      },
    },
    computedPerPage: {
      get() {
        this.firstPage = true;
        return this.perPageFilter || "10";
      },
      set(val) {
        this.updatePerPageFilter(val);
        this.tableView = parseInt(val) >= 500;
        this.firstPage = true;
        this.$nextTick(() => {
      this.debouncedFetch();
          this.saveState();
          this.syncPaginations();
        });
      },
    },
    computedPerPagegroup: {
      get() {
        this.firstPagegroup = true;
        return this.perPageFiltergroup || "300";
      },
      set(val) {
        this.updatePerPageFiltergroup(val);
        this.firstPagegroup = true;
        this.$nextTick(() => {
          this.debouncedGroupFetch();
        });
      },
    },
    computedPage: {
      get() {
        return this.pageFilter || 1;
      },
      set(val) {
        this.updatePageFilter(val);
      },
    },
    computedPagegroup: {
      get() {
        return this.pageFiltergroup || 1;
      },
      set(val) {
        this.updatePageFiltergroup(val);
      },
    },
    showCheck: {
      get() {
        return this.checked.length > 0;
      },
      set(val) {
        if (val) {
          if (this.checked.length === 0) this.checked.push(val);
        } else {
          this.checked = [];
        }
      },
    },
    showCheckgroup: {
      get() {
        return this.checkedgroup.length > 0;
      },
      set(val) {
        if (val) {
          if (this.checkedgroup.length === 0) this.checkedgroup.push(val);
        } else {
          this.checkedgroup = [];
        }
      },
    },
    filteredListgroup() {
      let filtered = this.listgroup;
      if (this.statusFiltergroup !== "all") {
        filtered = filtered.filter(
          (item) => item.status === this.statusFiltergroup,
        );
      }
      if (this.typeFiltergroup !== "all") {
        filtered = filtered.filter(
          (item) => item.type === this.typeFiltergroup,
        );
      }
      if (this.searchTypeFiltergroup.text) {
        filtered = filtered.filter(
          (item) =>
            item.title.includes(this.searchTypeFiltergroup.text) ||
            item.identifier.includes(this.searchTypeFiltergroup.text),
        );
      }
      if (this.userFiltergroup) {
        filtered = filtered.filter(
          (item) => item.user_id === this.userFiltergroup,
        );
      }
      if (this.identifierFiltergroup) {
        filtered = filtered.filter(
          (item) => item.identifier === this.identifierFiltergroup,
        );
      }
      if (this.idSearchFiltergroup) {
        filtered = filtered.filter(
          (item) => item.qr_id === this.idSearchFiltergroup,
        );
      }
      if (this.expireTypeFiltergroup) {
        filtered = filtered.filter(
          (item) => item.expire_type === this.expireTypeFiltergroup,
        );
      }
      return filtered;
    },
  },

  watch: {
    minimaltableView(newValue){
      this.page = 1; 
      this.list = []; 
      
      if (newValue) {
        this.minimalFetch();
      } else {
        this.fetch();
      }
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    "$route.query.refresh": {
      handler() {
        this.$nextTick(() => {
      this.debouncedFetch();
        });
        this.$forceUpdate();
      },
      immediate: true,
    },
    showTooltip(val) {
      if (val) {
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      }
    },
    tabs(val) {
      if (val === 0) {
        this.restoreState();
        this.saveState();
      } else {
        this.debouncedGroupFetch();
      }
    },
    typeChoice(val) {
      this.debouncedGroupFetch();
      this.selectedRowsgroup = [];
      // Update listDetail when typeChoice changes
      this.updateListDetailGroup();
    },

    computedPerPage(val) {
      this.tableView = parseInt(val) >= 500;
    },
    perPageFiltergroup(val) {
      this.firstPagegroup = true;
      this.$nextTick(() => {
        this.debouncedGroupFetch();
      });
    },
    perPageFilter(val) {
      this.tableView = parseInt(val) >= 500;
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
        this.syncPaginations();
      });
    },
    selectedRows(val) {
      const selectedIds = val.map((item) => item.id);
      this.changedSelected(selectedIds);
      // Update listDetail for first tab
      this.updateListDetail();
    },
    selectedRowsgroup(val) {
      const selectedIds = val.map((item) => item.id);
      this.changedSelectedgroup(selectedIds);
      // Update listDetail for second tab
      this.updateListDetailGroup();
    },
    tableView(val) {
      if (val && this.pagination) {
        this.$nextTick(() => {
          this.selectedRows = this.list.filter((item) => item.checkbox);
          this.showCheck = this.selectedRows.length > 0;
          this.syncPaginations();
        });
      }
    },
    "discountField.show"(val) {
      this.discountField.model = "";
    },
    list: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.checked = val
            .filter((item) => item.checkbox)
            .map((item) => "check-" + item.id);
          this.checkAll = this.checked.length >= this.list.length;
          this.selectedRows = val.filter((item) => item.checkbox);
        });
      },
    },
    checkAll(val) {
      if (val)
        this.list.forEach((item) => {
          this.$set(item, "checkbox", true);
        });
    },
    listgroup: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.checkedgroupd = val
            .filter((item) => item.checkbox)
            .map((item) => "check-" + item.id);
          this.checkAllgroup =
            this.checkedgroup.length >= this.listgroup.length;
        });
      },
    },
    checkAllgroup(val) {
      if (val)
        this.listgroup.forEach((item) => {
          this.$set(item, "checkbox", true);
        });
    },
    sortFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    statusFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    typeFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    searchTypeFilter: {
      deep: true,
      handler() {
        this.firstPage = true;
        this.$nextTick(() => {
      this.debouncedFetch();
        });
      },
    },
    userFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    identifierFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    idSearchFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    expireTypeFilter() {
      this.firstPage = true;
      this.$nextTick(() => {
      this.debouncedFetch();
      });
    },
    sortFiltergroup() {
      //sortFiltergroup() {
      this.firstPagegroup = true;
      this.debouncedGroupFetch();
    },
    statusFiltergroup() {
      this.firstPagegroup = true;

      this.$nextTick(() => {
        this.debouncedGroupFetch();
      });
    },
    typeFiltergroup() {
      this.firstPagegroup = true;
      this.$nextTick(() => {
        this.debouncedGroupFetch();
      });
    },
    searchTypeFiltergroup: {
      deep: true,
      handler() {
        this.firstPagegroup = true;
        this.$nextTick(() => {
          this.debouncedGroupFetch();
        });
      },
    },
    userFiltergroup() {
      this.$nextTick(() => {
        this.firstPagegroup = true;
        this.debouncedGroupFetch();
      });
    },
    identifierFiltergroup() {
      this.$nextTick(() => {
        this.firstPagegroup = true;
        this.debouncedGroupFetch();
      });
    },
    idSearchFiltergroup() {
      this.$nextTick(() => {
        this.firstPagegroup = true;
        this.debouncedGroupFetch();
      });
    },
    expireTypeFiltergroup() {
      this.$nextTick(() => {
        this.firstPagegroup = true;
        this.debouncedGroupFetch();
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.saveState();
    next();
  },
  activated() {
    this.restoreState();
  },
  methods: {
        formatPrice(amount) {
      if (!amount) return { num: 0, text: 'رایگان' };
      
      if (amount >= 1000000 && amount % 100000 === 0) {
        const num = amount / 1000000;
        return { num: Number.isInteger(num) ? num : num.toFixed(1), text: 'میلیون ریال' };
      } 
      else if (amount >= 1000 && amount % 1000 === 0) {
        return { num: amount / 1000, text: 'هزار ریال' };
      }      
      return { num: amount.toLocaleString(), text: 'ریال' };
    },
    getCardStyle(item) {
      const index = this.prices.findIndex(p => p.id === item.id);
      const totalLength = this.prices.length;
      const reverseIndex = totalLength - 1 - index; 
      
      switch (reverseIndex) {
            case 0: return { tag: 'باصرفه‌ترین', color: '#ffb300', icon: 'mdi-crown' }; 
            case 1: return { tag: 'پیشنهاد ویژه', color: '#1de9b6', icon: 'mdi-diamond-stone' }; 
            case 2: return { tag: 'محبوب', color: '#8c9eff', icon: 'mdi-star' }; 
            case 3: return { tag: 'اقتصادی', color: '#ff8a65', icon: 'mdi-wallet-bifold' }; 
            case 4: return { tag: 'پایه', color: '#4fc3f7', icon: 'mdi-flag-variant' }; 
            default: return { tag: 'عادی', color: '#90a4ae', icon: 'mdi-calendar-month' };
      }
    },

     getDiscountPercent(count) {
    const discounts = {
      10000: 98, 9500: 97, 9000: 96, 8500: 95, 8000: 94,
      7500: 93, 7000: 92, 6500: 91, 6000: 90, 5500: 89,
      5000: 88, 4500: 87, 4000: 86, 3500: 85, 3000: 84,
      2500: 83, 2000: 82, 1500: 81, 1000: 80, 900: 78,
      800: 76, 700: 74, 600: 72, 500: 70, 400: 65,
      300: 60, 200: 55, 100: 50, 75: 30, 50: 20,
      30: 15, 10: 10, 5: 5,
    };
    // Get thresholds and sort them in descending order
    const thresholds = Object.keys(discounts).map(Number).sort((a, b) => b - a);

    for (const threshold of thresholds) {
      if (count >= threshold) {
        return discounts[threshold];
      }
    }
    return 0;
  },
    debouncedFetch: debounce(function() {
      if (this.minimaltableView) {
        this.minimalFetch();
      } else {
        this.fetch();
      }
}, 300),

  debouncedGroupFetch: debounce(function() {
    this.fetchCountgroup();
    this.fetchgroup();
  }, 300),
  
    qrLink(item) {
      let link = item.domain?.name || "";

      if (!link.startsWith("http")) {
        link = "https://" + link;
      }

      if (!!item.extra_short?.identifier)
        return link + item.extra_short.identifier;
      return link;
    },
    copyUrl(link) {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(link)
          .then(() => {
            this.showTooltip = true;
          })
          .catch((err) => {});
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = link;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.showTooltip = true;
      }
    },
    ...mapActions("localstorage", [
      "updatePerPageFilter",
      "updateUserFilter",
      "updateIdentifierFilter",
      "updateIdSearchFilter",
      "updateExpireTypeFilter",
      "resetStates",
      "updateHasError",
      "updatePageFilter",
      "updateSortFilter",
      "updateStatusFilter",
      "updateTypeFilter",
      "updateSearchTypeFilter",
      "updatePerPageFiltergroup",
      "updatePageFiltergroup",
      "updateSortFiltergroup",
      "updateStatusFiltergroup",
      "updateTypeFiltergroup",
      "updateSearchTypeFiltergroup",
      "updateUserFiltergroup",
      "updateIdentifierFiltergroup",
      "updateIdSearchFiltergroup",
      "updateExpireTypeFiltergroup",
      "resetStatesGroup",
      "updateHasErrorgroup",
    ]),
    resetFilters() {
      this.selectedRowsgroup = [];
      this.resetStatesGroup();
      this.$nextTick(() => {
        this.debouncedGroupFetch();
      });
    },
    saveState() {
      try {
        const state = {
          page: this.computedPage || 1,
          perPage: this.computedPerPage || "10",
          sortFilter: this.sortFilter || "desc",
          statusFilter: this.statusFilter || "all",
          typeFilter: this.typeFilter || "all",
          searchTypeFilter: this.searchTypeFilter || { text: "" },
          userFilter: this.userFilter || null,
          identifierFilter: this.identifierFilter || null,
          idSearchFilter: this.idSearchFilter || null,
          expireTypeFilter: this.expireTypeFilter || null,
          tableView: this.tableView || false,
          scrollPosition: window.scrollY || 0,
        };
        sessionStorage.setItem("qrListState", JSON.stringify(state));
      } catch (error) {
        console.error("Error saving state:", error);
      }
    },
    restoreState() {
      try {
        const savedState = sessionStorage.getItem("qrListState");
        if (savedState) {
          const state = JSON.parse(savedState);
          this.tabs = state.activeTab || 0;
          this.updatePageFilter(state.page || 1);
          this.updatePerPageFilter(state.perPage || "10");
          this.updateSortFilter(state.sortFilter || "desc");
          this.updateStatusFilter(state.statusFilter || "all");
          this.updateTypeFilter(state.typeFilter || "all");
          this.updateSearchTypeFilter(state.searchTypeFilter || { text: "" });
          this.updateUserFilter(state.userFilter || null);
          this.updateIdentifierFilter(state.identifierFilter || null);
          this.updateIdSearchFilter(state.idSearchFilter || null);
          this.updateExpireTypeFilter(state.expireTypeFilter || null);
          this.tableView = state.tableView || false;
      this.debouncedFetch();
        } else {
          this.updatePerPageFilter("10");
      this.debouncedFetch();
        }
      } catch (error) {
        console.error("Error restoring state:", error);
        this.updatePerPageFilter("10");
      this.debouncedFetch();
      }
    },
    changedSelected(ids) {
      this.list.forEach((item) => {
        this.$set(item, "checkbox", ids.includes(item.id));
      });
      this.checked = this.list
        .filter((item) => item.checkbox)
        .map((item) => "check-" + item.id);
      this.checkAll = this.checked.length >= this.list.length;
    },
    changedSelectedgroup(ids) {
      this.listgroup.forEach((item) => {
        this.$set(item, "checkbox", ids.includes(item.id));
      });
      this.checkedgroup = this.listgroup
        .filter((item) => item.checkbox)
        .map((item) => "check-" + item.id);
      this.checkAllgroup = this.checkedgroup.length >= this.listgroup.length;
    },
    onPagination(e) {
      if (e !== this.computedPage) {
        this.updatePageFilter(e);
        this.$nextTick(() => {
      this.debouncedFetch();
          this.syncPaginations();
          this.saveState();
        });
      }
    },
    onPaginationgroup(e) {
      if (
        e.page !== this.computedPagegroup ||
        e.length !== this.computedPerPagegroup
      ) {
        this.updatePageFiltergroup(e.page);
        this.updatePerPageFiltergroup(e.length);
        this.$nextTick(() => {
          this.debouncedGroupFetch();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    onPerPage() {
      this.firstPage = true;
      this.updatePageFilter(1);
      this.$nextTick(() => {
      this.debouncedFetch();
        this.syncPaginations();
        this.saveState();
      });
    },
    onPerPagegroup() {
      this.firstPagegroup = true;
      this.updatePageFiltergroup(this.computedPagegroup);
      this.$nextTick(() => {
        this.debouncedGroupFetch();
      });
    },
    syncPaginations() {
      const refs = [
        this.$refs.paginationTop,
        this.$refs.paginationTop2,
        this.$refs.paginationTableTop,
        this.$refs.paginationTableBottom,
        this.$refs.paginationTableBottom2,
      ].filter((ref) => ref);
      refs.forEach((ref) => {
        if (ref) {
          ref.last_emit = this.computedPage || 1;
          ref.perPage =
            parseInt(this.computedPerPage) || (this.tableView ? 500 : 10);
        }
      });
    },
    fetchgroup(
      filter = this.sortFiltergroup,
      status = this.statusFiltergroup,
      search = this.searchTypeFiltergroup,
      type = this.typeFiltergroup,
    ) {
      if (this.loadinggroup) return Promise.resolve();

      const cacheKey = JSON.stringify({
        filter,
        status,
        search,
        type,
        page: this.computedPagegroup,
        perPage: this.computedPerPagegroup,
      });
      if (
        this.cachedListgroup &&
        this.cachedPaginationgroup &&
        this.lastCacheKeygroup === cacheKey
      ) {
        this.listgroup = this.cachedListgroup;
        this.paginationgroup = this.cachedPaginationgroup;
        this.loadinggroup = false;
        return Promise.resolve();
      }

      this.loadinggroup = true;
      //  this.updateHasErrorgroup(false);
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = filter;
      }

      if (status !== "all") {
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else {
          p.status = status;
        }
      }

      if (type !== "all") {
        p.type = type;
      }

      if (search?.text?.trim()?.length >= 1) {
        p.search = search.text;
      }

      if (search?.text?.trim() !== "" && search.type !== "search") {
        p.from = 1;
      }

      if (this.userFiltergroup) p.user_id = this.userFiltergroup;
      if (this.identifierFiltergroup) p.identifier = this.identifierFiltergroup;
      if (this.idSearchFiltergroup) p.qr_id = this.idSearchFiltergroup;
      if (
        !!this.expireTypeFiltergroup &&
        this.expireTypeFiltergroup?.expired_type !== ""
      )
        p.expire_type = this.expireTypeFiltergroup?.expired_type;
      p.page = this.typeChoice
        ? 1
        : this.firstPagegroup
        ? 1
        : this.computedPagegroup;
      p.length = this.typeChoice
        ? this.countDatagroup || 10000
        : parseInt(this.computedPerPagegroup) || 300;

      return this.$api
        .get(
          "/v1/testQr/user?fields[]=id&fields[]=title&fields[]=type&fields[]=domain_id&fields[]=identifier",
          { params: p },
        )
        .then(({ data }) => {
          this.paginationgroup = data.data;
          this.listgroup = data.data.data || [];
          this.firstPagegroup = false;
          this.cachedListgroup = this.listgroup;
          this.cachedPaginationgroup = this.paginationgroup;
          this.lastCacheKeygroup = cacheKey;
          this.fetchCountgroup();
          this.Showdetailgroup();
          this.updatePageFiltergroup(data.data.current_page || 1);
          this.updateListDetailGroup();
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.loadinggroup = false;
        });
    },
    minimalFetch(
      filter = this.sortFilter,
      status = this.statusFilter,
      search = this.searchTypeFilter,
      type = this.typeFilter,
    ) {
      if (this.loadinggroup) return Promise.resolve();

      const cacheKey = JSON.stringify({
        filter,
        status,
        search,
        type,
        page: this.computedPage,
        perPage: this.computedPerPage,
      });
      if (
        this.cachedList &&
        this.cachedPagination &&
        this.lastCacheKey === cacheKey
      ) {
        this.list = this.cachedList;
        this.pagination = this.cachedPagination;
        this.loading = false;
        return Promise.resolve();
      }

      this.loading = true;
      this.list = []; 
      //  this.updateHasErrorgroup(false);
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = filter;
      }

      if (status !== "all") {
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else {
          p.status = status;
        }
      }

      if (type !== "all") {
        p.type = type;
      }

      if (search?.text?.trim()?.length >= 1) {
        p.search = search.text;
      }

      if (search?.text?.trim() !== "" && search.type !== "search") {
        p.from = 1;
      }

      if (this.userFilte) p.user_id = this.userFilter;
      if (this.identifierFiltergroup) p.identifier = this.identifierFilter;
      if (this.idSearchFilter) p.qr_id = this.idSearchFilter;
      if (
        !!this.expireTypeFilter &&
        this.expireTypeFilter?.expired_type !== ""
      )
        p.expire_type = this.expireTypeFilter?.expired_type;
      p.page = this.typeChoice
        ? 1
        : this.firstPage
        ? 1
        : this.computedPage;
      p.length = this.typeChoice
        ? this.countData || 10000
        : parseInt(this.computedPerPage) || 300;

      return this.$api
        .get(
          "/v1/testQr/user?fields[]=id&fields[]=title&fields[]=type&fields[]=domain_id&fields[]=identifier&fields[]=clicks&fields[]=img_url&fields[]=dest_link&fields[]=expire_at&fields[]=created_at&fields[]=updated_at",
          { params: p },
        )
        .then(({ data }) => {
          this.pagination = data.data;
          this.list = data.data.data || [];
          this.firstPage = false;
          this.cachedList = this.list;
          this.cachedPagination = this.pagination;
          this.lastCacheKey = cacheKey;
          this.fetchCount();
          this.Showdetail();
          this.updatePageFilter(data.data.current_page || 1);
          this.updateListDetail();
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    Showdetailgroup(
      filter = this.sortFiltergroup,
      status = this.statusFiltergroup,
      search = this.searchTypeFiltergroup,
      type = this.typeFiltergroup,
    ) {
      const cacheKey = JSON.stringify({
        filter,
        status,
        search,
        type,
        page: this.computedPagegroup,
        perPage: this.computedPerPagegroup,
      });
      this.loadinggroup = true;
      //  this.updateHasErrorgroup(false);
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = filter;
      }

      if (status !== "all") {
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else {
          p.status = status;
        }
      }

      if (type !== "all") {
        p.type = type;
      }

      if (search?.text?.length >= 1) {
        p.search = search.text;
      }
      if (search?.text?.trim() !== "" && search.type !== "search") {
        p.from = 1;
      }

      if (this.userFiltergroup) p.user_id = this.userFiltergroup;
      if (this.identifierFiltergroup) p.identifier = this.identifierFiltergroup;
      if (this.idSearchFiltergroup) p.qr_id = this.idSearchFiltergroup;
      if (
        !!this.expireTypeFiltergroup &&
        this.expireTypeFiltergroup?.expired_type !== ""
      )
        p.expire_type = this.expireTypeFiltergroup;
      p.page = this.typeChoice
        ? 1
        : this.firstPagegroup
        ? 1
        : this.computedPagegroup;
      p.length = this.typeChoice
        ? this.countDatagroup || 10000
        : parseInt(this.computedPerPagegroup) || 300;
      // Update listDetail based on current state
      this.updateListDetailGroup();
      this.loadinggroup = false;
    },

    clearScrollPosition() {
      try {
        const savedState = sessionStorage.getItem("qrListState");
        if (savedState) {
          const state = JSON.parse(savedState);
          state.scrollPosition = 0;
          sessionStorage.setItem("qrListState", JSON.stringify(state));
        }
      } catch (error) {
        console.error("Error clearing scrollPosition:", error);
      }
    },
    async fetchNFC(info, identifier) {
      const selectedId = info?.qrId || null;
      if (!selectedId || !identifier) {
        this.$toast.error(this.$t("no_qr_or_id_selected"));
        return;
      }
      this.$set(this.imageLoadingMap, selectedId, true);
      this.imageLoading = true;

      try {
        this.NewidentifierShortLink = identifier;
        this.infoSelected = info;

        await this.updateQrWithRandomDesign();

        await this.$nextTick();

        await new Promise((resolve) => {
          const checkSvg = () => {
            if (
              this.NewqrSvgDataUrl !== "" &&
              this.NewqrSvgDataUrl !== "https://qr2.in/"
            ) {
              resolve();
            } else {
              setTimeout(checkSvg(), 20000);
            }
          };
          checkSvg();
        });
        const data = new FormData();
        if (this.$route.fullPath.includes("qr/design2")) {
          data.append("title", this.infoSelected.title);
          data.append("type", this.infoSelected.type);
          data.append("identifier", this.infoSelected.identifier);
          data.append("qr_id", this.infoSelected.qrId);
          data.append("image", this.NewqrSvgDataUrl);
          data.append("qr", JSON.stringify(this.NewqrDesign));
        } else {
          data.append("domain", this?.infoSelected?.domain?.name);
          data.append("identifier", this.infoSelected.identifier);
          data.append("type", this.infoSelected.type);
          data.append("qr_id", this.infoSelected.qrId);
          data.append("image", this.NewqrSvgDataUrl);
          data.append("qr", JSON.stringify(this.NewqrDesign));
        }

        const updatedCardTexts = { ...this.infoSelected.data.data };

        const updatedData = { ...this.originData, data: updatedCardTexts };

        data.append("_method", "PUT");
        const res = await this.$api.post("/v1/testQr/update", data, {
          // headers: { "Content-Type": "multipart/form-data" },
          headers: { "Content-Type": "application/from-data" },
        });
        this.$toast.success(this.$t("qr_updated_successfully"));
        this.infoSelected = {
          ...this.infoSelected,
          qr: JSON.stringify(this.NewqrDesign),
          img_url: res.data.data.img_url,
        };
        const index = this.list.findIndex(
          (item) => item.qrId === this.infoSelected.qrId,
        );
        if (index !== -1) {
          this.$set(this.list, index, this.infoSelected);
        }

        //  await this.fetch();
      } catch (err) {
        this.$toast.error(this.$t("error_updating_qr"));
      } finally {
        this.$set(this.imageLoadingMap, selectedId, false);
        this.NewqrDesign = null;
        this.NewqrSvgDataUrl = null;
        // this.imageLoading = false;
      }
    },
    async findDataInfo(identifier, domain) {
      this.$api
        .get(`/v1/testQr/find/${domain}${!!identifier ? "/" + identifier : ""}`)
        .then(({ data }) => {
          this.data = data.data;
        });
    },
    async updateQrWithRandomDesign() {
      if (!this.NewidentifierShortLink || !this.infoSelected) {
        this.$toast.error(this.$t("no_qr_selected"));
        return;
      }
      this.qrDesign = { ...this.info.qr };
      await this.$nextTick();
      if (this.$refs.qrCanvas && !!this.NewidentifierShortLink) {
        await this.$refs.qrCanvas.appendCanvas(
          `https://qr2.in/${this.NewidentifierShortLink}`,
        );
      }
      await this.$nextTick();
      await new Promise((resolve) => {
        let retryCount = 0;
        const maxRetries = 2;

        const checkSvg = () => {
          if (
            this.NewqrSvgDataUrl &&
            this.NewqrSvgDataUrl !== "" &&
            !this.NewqrSvgDataUrl.startsWith("https://qr2.in/")
          ) {
            if (this.NewqrSvgDataUrl.startsWith("data:image/svg+xml")) {
              const base64 = this.NewqrSvgDataUrl.split(",")[1];
              const decoded = atob(base64);
              if (!decoded.includes(this.NewidentifierShortLink)) {
                if (retryCount < maxRetries && this.$refs.qrCanvas) {
                  retryCount++;
                  this.$refs.qrCanvas.getDataUrl();
                  setTimeout(checkSvg, 1000);
                  return;
                }
              }
            }
            resolve();
          } else {
            setTimeout(checkSvg, 200);
          }
        };
        checkSvg();
      });
      await this.$nextTick();
    },
    fetch(
      filter = this.sortFilter,
      status = this.statusFilter,
      search = this.searchTypeFilter,
      type = this.typeFilter,
    ) {
      if (this.loading) return Promise.resolve();

      const cacheKey = JSON.stringify({
        filter,
        status,
        search,
        type,
        page: this.computedPage,
        perPage: this.computedPerPage,
      });
      if (
        this.cachedList &&
        this.cachedPagination &&
        this.lastCacheKey === cacheKey
      ) {
        this.list = this.cachedList;
        this.pagination = this.cachedPagination;
        this.loading = false;
        return Promise.resolve();
      }

      this.loading = true;
      //    this.updateHasError(false);
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = filter;
      }

      if (status !== "all") {
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else {
          p.status = status;
        }
      }

      if (type !== "all") p.type = type;

      if (search?.text?.length >= 1) p.search = search.text;

      if (search?.text.trim() !== "" && search.type !== "search") p.from = 1;

      if (this.userFilter) p.user_id = this.userFilter;
      if (this.identifierFilter) p.identifier = this.identifierFilter;
      if (this.idSearchFilter) p.qr_id = this.idSearchFilter;
      if (this.expireTypeFilter && this.expireTypeFilter.expire_type !== "")
        p.expire_type = this.expireTypeFilter?.expire_type;

      p.page = this.firstPage ? 1 : this.computedPage;
      p.length = parseInt(this.computedPerPage) || (this.tableView ? 500 : 10);

      return this.$api
        .get("/v1/testQr/user", { params: p })
        .then(({ data }) => {
          this.pagination = data.data;
          this.list = data.data.data || [];
          this.firstPage = false;
          this.cachedList = this.list;
          this.cachedPagination = this.pagination;
          this.lastCacheKey = cacheKey;
          this.updatePageFilter(data.data.current_page || 1);
          this.$nextTick(() => {
            this.syncPaginations();
          });
          const savedState = sessionStorage.getItem("qrListState");
          if (savedState) {
            const state = JSON.parse(savedState);
            this.$nextTick(() => {
              requestAnimationFrame(() => {
                window.scrollTo({
                  top: state.scrollPosition || 0,
                  behavior: "smooth",
                });
              });
            });
          }
        })

        .finally(() => {
          this.loading = false;
          this.clearScrollPosition();
        });
    },
    async massUpdate(time) {
      this.paymentloading = true;
      const ids = this.list
        .filter((item) => item.checkbox)
        .map((item) => item.id);
      if (!ids.length) {
        this.$toast.error(this.$t("no_qr_code_selected"));
        this.paymentloading = false;
        return;
      }
      this.loading = true;
      try {
        const { data } = await this.$api.put("user/price/mass/upgrade", {
          ids,
          time,
        });
         await this.debouncedFetch();
        this.$modal.success(
          this.$t("success"),
          this.$t("qrs_upgraded_successfully"),
        );
        // Close popup after success and reset time
        this.$nextTick(() => {
          this.massUpdatePriceData = { close: true };
          // Reset time in listCardHeader component
          if (this.$refs.listCardHeader) {
            this.$refs.listCardHeader.time = 0;
          }
        });
      } catch (error) {
        this.$modal.error(
          this.$t("error"),
          this.$t("problem_with_qr_renewal_request"),
        );
      } finally {
        this.loading = false;
        this.paymentloading = false;
      }
    },
    changeCheckAll(value) {
      if (!value) {
        this.list.forEach((item) => {
          this.$set(item, "checkbox", false);
        });
      } else {
        this.$nextTick(() => {
          this.checked = this.list
            .filter((item) => item.checkbox)
            .map((item) => "check-" + item.id);
        });
      }
    },
    changeCheckAllgroup(value) {
      if (!value) {
        this.listgroup.forEach((item) => {
          this.$set(item, "checkbox", false);
        });
      } else {
        this.$nextTick(() => {
          this.checkedgroup = this.listgroup
            .filter((item) => item.checkbox)
            .map((item) => "check-" + item.id);
        });
      }
    },
    pauseSelected(e) {
      this.loading = true;

      let identifier = this.list?.filter((item) => !!item.checkbox);
      let domain = identifier
        .filter((item) => !item.identifier)
        .map((item) => item.domain?.name);
      identifier = identifier
        .filter((item) => !!item.identifier)
        .map((item) => item.identifier);

      let obj = {
        status: e,
      };

      if (!!identifier.length) obj.qr = identifier;
      if (!!domain?.length) obj.domain = domain;

      this.$api
        .post("/api/v1/testQr/change-status", obj)
        .then(({ data }) => {
      this.debouncedFetch();

          this.$toast.success(this.$t("changed_successfully"));
        })
        .catch(({ response }) => {
          this.$toast.error(this.$t("error_occurred"));
        })
        .finally(() => (this.loading = false));
    },
    bulkDownload() {},
    getPrices(e) {
      this.info = e;
      this.priceloading = true;
      let types = this.getQrTypes().map((item) => item.value);
      let index =
        types.findIndex(
          (item) => item.toLowerCase() === e.type.toLowerCase(),
        ) || -1;

      this.$api
        .get("user/price", { params: { type: types[index] } })
        .then((response) => {
          this.prices =
            response.data.data.sort((a, b) => a.time - b.time) || [];

          // this.prices = response.data.data || [];
          this.priceDial = true;
        })
        .catch(({ response }) => {
          if (
            response &&
            response.data &&
            response.data.errors &&
            Object.keys(response.data.errors).length > 0
          ) {
            this.$modal.error(
              this.$t("error"),
              Object.values(response.data.errors)[0][0],
            );
          } else
            this.$modal.error(this.$t("error"), this.$t("no_tariff_exists"));
        })
        .finally(() => (this.priceloading = false));
    },
    fillInfo(e) {
      this.info = e;
      this.showDialog = true;
    },
    upgradeQr(priceId) {
      this.priceloading = true;
      this.$api
        .put(`user/price/upgrade/${this.info.id}/${priceId}`, {
          discount_code: !!this.discountField.model
            ? this.discountField.model
            : undefined,
        })
        .then(({ data }) => {
          this.priceDial = false;
          this.priceloading = false;
          this.$modal.success(
            this.$t("success"),
            this.$t("qr_upgraded_successfully"),
          );
      this.debouncedFetch();

        })
        .catch(({ response }) => {
          this.priceloading = false;
          if (response?.status === 402)
            this.$modal.error(
              this.$t("error"),
              this.$t("check_account_balance_and_try_again"),
            );
          else if (reason.response.status === 422)
            this.$modal.error("خطا",response?.data?.message|| response?.message || response?.error?.message);
          else
            this.$modal.error(
              this.$t("error"),
              this.$t("problem_with_qr_renewal_request"),
            );
        });
    },
    printQr(e) {
      this.info = e;
      this.showPrint = true;
    },
    computedDiscount(price) {
      let p = Math.floor((price.discount * price.price) / 100);
      return price.price - p;
    },
    async showModal({ info, type }) {
      if (!info) return;
      this.info = info;
      await this.$nextTick();
      switch (type) {
        case "transactions":
          this.transactionsShow = true;
          break;
        case "users":
          this.showUsersList = true;
          break;
        case "orders":
          this.showOrdersList = true;
          break;
        case "appointments":
          this.showAppointmentsList = true;
          break;
        case "ownership":
          this.showOwnershipList = true;
          break;
        case "nfc":
          this.showNfcList = true;
          break;
        case "feedback":
          this.showFeedBackList = true;
          break;
        case "form":
          this.showForm = true;
          break;
        case "wheel_winner_list":
          this.showWinnersList = true;
          break;
        case "employee_list":
          this.showEmployeeList = true;
          break;
        case "attendace_list":
          this.showAttendanceList = true;
          break;

      }
    },
    massUpdatePrice(time) {
      const ids = this.list
        ?.filter((item) => !!item.checkbox)
        .map((item) => item.id);
      this.loading = true;
      this.priceloading = true;
      this.$api
        .post(`user/price/mass`, {
          ids,
          time,
        })
        .then((res) => {
          this.massUpdatePriceData = res.data.data || {};
        })
        .catch(() => {
          this.$toast.error(this.$t("error_getting_group_renewal_price"));
        })
        .finally(() => {
          this.loading = false;
          this.priceloading = false;
        });
    },

    // متدهای تب دوم
    saveStategroup() {
      try {
        const state = {
          page: 1,
          perPage: this.countDatagroup || "500",
          sortFilter: this.sortFiltergroup || "desc",
          statusFilter: this.statusFiltergroup || "all",
          typeFilter: this.typeFiltergroup || "all",
          searchTypeFilter: this.searchTypeFiltergroup || { text: "" },
          userFilter: this.userFiltergroup || null,
          identifierFilter: this.identifierFiltergroup || null,
          idSearchFilter: this.idSearchFiltergroup || null,
          expireTypeFilter: this.expireTypeFiltergroup || null,
          scrollPosition: window.scrollY || 0,
        };
        sessionStorage.setItem("qrListStateGroup", JSON.stringify(state));
      } catch (error) {}
    },
    restoreStategroup() {
      try {
        const savedState = sessionStorage.getItem("qrListStateGroup");
        if (savedState) {
          const state = JSON.parse(savedState);
          this.updatePageFiltergroup(state.page || 1);
          this.updatePerPageFiltergroup(state.perPage || "10");
          this.updateSortFiltergroup(state.sortFilter || "desc");
          this.updateStatusFiltergroup(state.statusFilter || "all");
          this.updateTypeFiltergroup(state.typeFilter || "all");
          this.updateSearchTypeFiltergroup(
            state.searchTypeFilter || { text: "" },
          );
          this.updateUserFiltergroup(state.userFilter || null);
          this.updateIdentifierFiltergroup(state.identifierFilter || null);
          this.updateIdSearchFiltergroup(state.idSearchFilter || null);
          this.updateExpireTypeFiltergroup(state.expireTypeFilter || null);
        } else {
          this.fetchCountgroup(true);
        }
      } catch (error) {
        this.fetchCountgroup(true);
      }
    },
    fetchCountgroup(initial = false) {
      const params = initial
        ? { sort: "desc" }
        : {
            search: this.searchTypeFiltergroup?.text || "",
            sort: this.sortFiltergroup || "desc",
            user_id: this.userFiltergroup || undefined,
            identifier: this.identifierFiltergroup || undefined,
            qr_id: this.idSearchFiltergroup || undefined,
            expire_type: this.expireTypeFiltergroup || undefined,
            type:
              this.typeFiltergroup !== "all" ? this.typeFiltergroup : undefined,
            status:
              this.statusFiltergroup !== "all"
                ? this.statusFiltergroup
                : undefined,
            expired: ["1", "near"].includes(this.statusFiltergroup)
              ? this.statusFiltergroup
              : undefined,
          };
      this.countData2group(params);
    },
    countData2group(params = {}) {
      try {
        const defaultParams = {
          sort: params.sort || "desc",
          search: params.search || "",
          user_id: params.user_id,
          identifier: params.identifier,
          qr_id: params.qr_id,
          expire_type: params.expire_type,
          type: params.type,
          status: params.status,
          expired: params.expired,
        };

        this.$api
          .get("/v1/testQr/user/count", { params: defaultParams })
          .then(({ data }) => {
            this.countDatagroup = data?.data?.count || 0;
          })
          .catch(() => {
            this.$toast.error(this.$t("error_getting_qr_codes_count"));
            this.countDatagroup = 0;
          });
      } catch (error) {
        this.$toast.error(this.$t("error_getting_qr_codes_count"));
        this.countDatagroup = 0;
      }
    },
    async massUpdateGroup(
      time,
      filter = this.sortFiltergroup,
      status = this.statusFiltergroup,
      search = this.searchTypeFiltergroup,
      type = this.typeFiltergroup,
    ) {
      this.paymentloading = true;
      //  this.updateHasErrorgroup(false);
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = filter;
      }

      if (status !== "all") {
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else {
          p.status = status;
        }
      }

      if (type !== "all") {
        p.type = type;
      }

      if (search?.text?.length >= 1) {
        p.search = search.text;
      }

      if (search?.text.trim() !== "" && search.type !== "search") {
        p.from = 1;
      }

      if (this.userFiltergroup) p.user_id = this.userFiltergroup;
      if (this.identifierFiltergroup) p.identifier = this.identifierFiltergroup;
      if (this.idSearchFiltergroup) p.qr_id = this.idSearchFiltergroup;
      if (
        !!this.expireTypeFiltergroup &&
        this.expireTypeFiltergroup?.expired_type !== ""
      )
        p.expire_type = this.expireTypeFiltergroup;
      p.page = !this.typeChoice
        ? 1
        : this.firstPagegroup
        ? 1
        : this.computedPagegroup;
      p.length = this.typeChoice
        ? this.countDatagroup || 10000
        : parseInt(this.computedPerPagegroup) || 300;
      p.time = time;
      if (
        this.filteredListgroup.length <= 0 &&
        this.countDatagroup <= 0 &&
        this.selectedRowsgroup.length === 0
      ) {
        this.$toast.error(this.$t("no_qr_codes_for_renewal"));
        return;
      }
      try {
        if (this.typeChoice) {
          //all
          let params = p;

          const { data } = await this.$api.put(
            "user/price/mass/upgrade/filters?sort=desc",
            params,
          );
        } else {
          let params = {
            ids: this.selectedRowsgroup.map((item) => item.id),
            time,
          };

          const { data } = await this.$api.put(
            "user/price/mass/upgrade",
            params,
          );
        }
        this.debouncedGroupFetch();
        this.$modal.success(
          this.$t("success"),
          this.$t("qrs_upgraded_successfully"),
        );
        // Close popup after success and reset time
        this.$nextTick(() => {
          this.massUpdatePriceDatagroup = { close: true };
          // Reset time in listCardHeadergroup component
          if (this.$refs.listCardHeadergroup) {
            this.$refs.listCardHeadergroup.time = 0;
          }
        });
      } catch (error) {
        if (error.response.status === 422)
            this.$modal.error("خطا",error.response?.data?.message|| error.response?.message || error.response?.error?.message);
        else
            this.$modal.error(
              this.$t("error"),
              this.$t("problem_with_qr_renewal_request"),
            );
      } finally {
        this.paymentloading = false;
      }
    },
    async massUpdatePricegroup(
      time,
      filter = this.sortFiltergroup,
      status = this.statusFiltergroup,
      search = this.searchTypeFiltergroup,
      type = this.typeFiltergroup,
    ) {
      this.loadinggroup = true;
      //  this.updateHasErrorgroup(false);
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(filter)) {
        p.clicks = filter === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = filter;
      }

      if (status !== "all") {
        if (["1", "near"].includes(status)) {
          p.expired = status;
        } else {
          p.status = status;
        }
      }

      if (type !== "all") {
        p.type = type;
      }

      if (search?.text?.trim()?.length >= 1) {
        p.search = search.text;
      }

      if (search?.text?.trim() !== "" && search.type !== "search") {
        p.from = 1;
      }

      if (this.userFiltergroup) p.user_id = this.userFiltergroup;
      if (this.identifierFiltergroup) p.identifier = this.identifierFiltergroup;
      if (this.idSearchFiltergroup) p.qr_id = this.idSearchFiltergroup;
      if (
        !!this.expireTypeFiltergroup &&
        this.expireTypeFiltergroup?.expired_type !== ""
      )
        p.expire_type = this.expireTypeFiltergroup;
      p.page = this.typeChoice
        ? 1
        : this.firstPagegroup
        ? 1
        : this.computedPagegroup;
      p.length = this.typeChoice
        ? this.countDatagroup || 10000
        : parseInt(this.computedPerPagegroup) || 300;
      p.time = time;
      if (this.countDatagroup <= 0 && this.selectedRowsgroup.length === 0) {
        this.$toast.error(this.$t("no_qr_codes_for_renewal"));
        return;
      }

      try {
        this.loadinggroup = true;
        if (!this.typeChoice) {
          const params = {
            ids: this.selectedRowsgroup.map((item) => item.id),
            time,
          };
          const { data } = await this.$api.post("user/price/mass", params);
          this.massUpdatePriceDatagroup = data.data || {};
        } else {
          const params = p;

          const { data } = await this.$api.post(
            "user/price/mass/filter",
            params,
          );
          this.massUpdatePriceDatagroup = data.data || {};
        }
      } catch (error) {
        this.$toast.error(this.$t("error_getting_group_renewal_price"));
      } finally {
        this.loadinggroup = false;
      }
    },
    pauseSelectedgroup(e) {
      let identifier = !this.typeChoice
        ? this.listfgroup
        : this.listgroup?.filter((item) => !!item.checkbox);
      let domain = identifier
        .filter((item) => !item.identifier)
        .map((item) => item.domain?.name);
      identifier = identifier
        .filter((item) => !!item.identifier)
        .map((item) => item.identifier);

      let obj = {
        status: e,
      };

      if (!!identifier.length) obj.qr = identifier;
      if (!!domain?.length) obj.domain = domain;

      this.$api
        .post("/api/v1/testQr/change-status", obj)
        .then(({ data }) => {
          this.debouncedGroupFetch();
          this.$toast.success(this.$t("changed_successfully"));
        })
        .catch(({ response }) => {
          this.$toast.error(this.$t("error_occurred"));
        })
        .finally(() => (this.loadinggroup = false));
    },
    updateListDetail() {
      if (this.selectedRows && this.selectedRows.length > 0) {
        let count = [];
        this.selectedRows.forEach((element) => {
          const type = element.type || "unknown";
          count[type] = (count[type] || 0) + 1;
        });
        this.listDetail = Object.keys(count).map((x) => ({
          key: x,
          value: count[x],
        }));
        console.log(this.listDetail, "listdetail-detail");
      } else {
        this.listDetail = [];
      }
    },
    updateListDetailGroup() {
      if (this.typeChoice) {
        this.fetchListDetailFromAPI();
        console.log(this.listDetail, "listdetial-all");
      } else {
        // If specific items are selected, count from selectedRowsgroup
        if (this.selectedRowsgroup && this.selectedRowsgroup.length > 0) {
          let count = [];
          this.selectedRowsgroup.forEach((element) => {
            const type = element.type || "unknown";
            count[type] = (count[type] || 0) + 1;
          });
          this.listDetail = Object.keys(count).map((x) => ({
            key: x,
            value: count[x],
          }));
          console.log(this.listDetail, "listdetial-listDetail");
        } else {
          this.listDetail = [];
        }
      }
    },
    fetchListDetailFromAPI() {
      let p = {};

      if (["fewerVisited", "mostVisited"].includes(this.sortFiltergroup)) {
        p.clicks = this.sortFiltergroup === "mostVisited" ? "desc" : "asc";
      } else {
        p.sort = this.sortFiltergroup;
      }

      if (this.statusFiltergroup !== "all") {
        if (["1", "near"].includes(this.statusFiltergroup)) {
          p.expired = this.statusFiltergroup;
        } else {
          p.status = this.statusFiltergroup;
        }
      }

      if (this.typeFiltergroup !== "all") {
        p.type = this.typeFiltergroup;
      }

      if (this.searchTypeFiltergroup?.text?.length >= 1) {
        p.search = this.searchTypeFiltergroup.text;
      }

      if (this.userFiltergroup) p.user_id = this.userFiltergroup;
      if (this.identifierFiltergroup) p.identifier = this.identifierFiltergroup;
      if (this.idSearchFiltergroup) p.qr_id = this.idSearchFiltergroup;
      if (
        !!this.expireTypeFiltergroup &&
        this.expireTypeFiltergroup?.expired_type !== ""
      ) {
        p.expire_type = this.expireTypeFiltergroup;
      }

      p.page = 1;
      p.length = this.countDatagroup || 10000;

      return this.$api
        .get(
          "/v1/testQr/user?fields[]=id&fields[]=title&fields[]=type&fields[]=domain_id&fields[]=identifier&sort=desc&&response=count",
          { params: p },
        )
        .then(({ data }) => {
          this.listDetail = data.data || [];
          console.log(this.listDetail, "listDetail-api");
        })
        .catch(({ response }) => {
          this.listDetail = [];
        });
    },
  },
  beforeDestroy() {
    this.$root.$off("fillInfo", this.fillInfo);
    this.$root.$off("getPrices", this.getPrices);
  },
};
</script>

<style scoped>
.hidden-column {
  display: none !important;
  width: 0px;
}

.comp {
  display: flex;
  flex-wrap: nowrap !important;
}

.expire-option {
  width: 100%;
  white-space: nowrap;
  padding: 2px 8px;
  text-align: center;
  border-radius: 4px;
  background-color: forestgreen;
  color: white;
}

.expire-option.in-month {
  background-color: var(--v-warning-base);
  color: white;
}

.expire-option.in-days {
  background-color: darkorange;
  color: white;
}

.expire-option.in-expire {
  background-color: var(--v-third-base);
  color: white;
}

.v-row[ref="scrollContainer"] {
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

.messageEmpty {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 70px;
  font-size: large;
}

.typechoice {
  padding-top: 0;
  margin-top: 0px;
  margin-right: 10px;
}

.typechoice,
:deep(.v-switch) {
  font-size: 11px !important;
  color: black;
}

:deep(.typechoice .v-input__slot .v-label) {
  font-size: 11px !important;
  color: black;
}

.dic {
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-self: center;
  text-align: center;
}

.countshow {
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 0px;
  margin: 0px;
}

.link {
  cursor: pointer;
}
</style>
